import React from 'react';
import loadable from '@loadable/component';

import { loadGraphQLData } from '../page';
import { Helpers } from '../core/src/helpers';

const MDP = loadable(() => Helpers.retryFunc(() => import('./mdp-container')));

export default {
    component: MDP,
    loadData: loadGraphQLData,
};
